export default __webpack_public_path__ + "static/media/manageOrders.0a7721a0.svg";